import React from 'react';
import {BiPlus} from 'react-icons/bi';
import {ExpandedButton, ExpandedButtonText} from './styles';

export default ({text, icon, callback, dataCy}: {text: string; icon?: string; callback?: any; dataCy?: string}) => (
  <ExpandedButton onClick={callback} data-cy={dataCy}>
    {icon === 'plus' ? <BiPlus color="#CDD0D9" size="18px" /> : <></>}
    <ExpandedButtonText>{text}</ExpandedButtonText>
  </ExpandedButton>
);
